export default "__VITE_ASSET__qr6Rcn0L__"